<template>
    <v-container>
        
        <v-toolbar>
            <v-btn small color="secundary" @click="goBack"> <v-icon aria-hidden="false">mdi-arrow-left</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="printSection">
                <v-icon aria-hidden="false">mdi-printer-pos</v-icon>
                Print
            </v-btn>
        </v-toolbar>
        <br/>
        <v-flex xs12>
        <div id="printSection">
            <v-card-title><h2>{{title}}</h2></v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer>

                </v-data-table>
            </v-card-text>
        </div>
        </v-flex>
    
    </v-container>
    
</template>
<script>


export default{
 name:'PrintReport',
 props:{
     title:String,
     items:Array,
     headers:Array
 },
 methods:{
     async printSection(){
         this.$htmlToPaper("printSection");
     },
     async goBack(){
         this.$emit('clicked',false);
     }
 }

}
</script>
